module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/regimen/cabecera.jpg
// module id = 8b4B
// module chunks = 0